import 'bootstrap/dist/js/bootstrap.js';
import React, { Component } from 'react';
import { IntlProvider } from 'react-intl';
import { Route, Router, Switch } from 'react-router-dom';
import Config from '../commons/config/Config.js';
// NoDisponible removed — component was imported but never rendered
import Suspension from './app/Suspension.js';
import Reintentos from './app/Reintentos.js';
import Activate from './auth/Activate.js';
import AzureCallback from './auth/AzureCallback.js';
import GoogleCallback from './auth/GoogleCallback.js';
import OktaCallback from './auth/OktaCallback.js';
import ForgotPassword from './auth/ForgotPassword.js';
import GeotabLogin from './auth/GeotabLogin.js';
import InternalLogin from './auth/InternalLogin.js';
import Login from './auth/Login.js';
import PointerLogin from './auth/PointerLogin.js';
import RecoverPassword from './auth/RecoverPassword.js';
import TwoFA from './auth/TwoFA.js';
import TwoFATotp from './auth/TwoFATotp.js';
import TwoFATotpSetup from './auth/TwoFATotpSetup.js';
import Layout from './layout/Layout.js';
import TagManager from 'react-gtm-module'
import { createBrowserHistory } from 'history';
import ReporteFormulario from './reportarIncidentes/ReporteFormulario.js';
import SafeFeedbackFormularioRespuesta from './safeFeedback/SafeFeedbackFormularioRespuesta.js';
import swall2 from 'sweetalert2';
const customHistory = createBrowserHistory();

class App extends Component {
    constructor(props) {
        super(props);

        const countdown = parseInt(localStorage.getItem('countdown')) || 5;
        const retryCount = parseInt(localStorage.getItem('retryCount')) || 0;

        this.state = {
            authorized: null,
            errorConfig: false,
            retryCount: retryCount,
            countdown: countdown,
            configBusinessOk: false,
            configBusinessLoading: true,
            sistemaSuspendido: false,
        };

        this.startCountdown = this.startCountdown.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
        this.stopTimer = this.stopTimer.bind(this);
        this.loadConfigBusiness = this.loadConfigBusiness.bind(this);
    }

    componentDidMount() {
        this.loadConfigBusiness();
    }

    loadConfigBusiness() {
        this.setState({ configBusinessLoading: true });
        this.getConfig()
            .then(() => this.checkSession());
        this.getConfigBusiness()
            .then(() => {
                this.setState({ configBusinessLoading: false });
                // Reset de contadores si fue exitoso
                localStorage.removeItem('retryCount');
                localStorage.removeItem('countdown');
                this.setState({ retryCount: 0, countdown: 0 });
            })
            .catch(() => {
                this.setState({ configBusinessLoading: false });
                this.handleRetry();
            });
    }

    async getConfig() {
        try {
            const response = await fetch('/config/config.json', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            const configData = await response.json();
            localStorage.setItem('config', JSON.stringify(configData));
        } catch (error) {
            console.log(error);
        }
    }

    async getConfigBusiness() {
        const fetchConfigBusiness = () => {
            return fetch(Config.get('apiUrlBase') + '/commons/config-business', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            });
        };

        try {
            const response = await fetchConfigBusiness();
            if (!response.ok) {
                throw new Error('Error al obtener la configuración de entorno');
            }
            const data = await response.json();
            if ((data.jsonDownloaded && data.jsonDownloaded.complete === 'true')
                || (!data.json && data.json !== "error")) {
                localStorage.setItem("configBusiness", JSON.stringify(data));
                if(data.generales && data.generales.sistemaSuspendido === 'true'){
                    this.setState({ sistemaSuspendido: true });
                }else{
                    let GTM = data.frontend ?  (data.frontend.GTM ? data.frontend.GTM : 'GTM-00000000') : 'GTM-00000000'
                    TagManager.initialize({gtmId: GTM})

                    this.unlisten = customHistory.listen((location, action) => {
                        TagManager.dataLayer({
                            dataLayer: {
                                event: 'pageview',
                                pagePath: location.pathname,
                                pageTitle: document.title,
                                page: { url: window.location.href, action: action }
                            }
                        });
                    });

                    this.setState({ configBusinessOk: true });
                }
            } else {
                throw new Error('Configuración de entorno incompleta');
            }
        } catch (error) {
            console.log('Error en configuración de entorno', error);
            throw error; // Re-lanzar para que lo agarre el catch de loadConfigBusiness
        }
    }

    checkSession() {
        return new Promise((resolve, reject) => {
            const token = localStorage.getItem('token');
            if (token) {
                fetch(Config.get('apiUrlBase') + '/auth/check', {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization-Token': token,
                    },
                })
                    .then((response) => {
                        this.setState({
                            authorized: response.status === 200,
                        });
                        if (response.status === 200) resolve();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
                this.setState({
                    authorized: false,
                });
            }
        });
    }

    startCountdown() {
        const countdownInterval = setInterval(() => {
            this.setState(
                (prevState) => {
                    const newCountdown = prevState.countdown - 1;
                    localStorage.setItem('countdown', newCountdown.toString());
                    return { countdown: newCountdown };
                },
                () => {
                    if (this.state.countdown <= 0) {
                        clearInterval(countdownInterval);
                        this.getConfigBusiness()
                            .then(() => {
                                // Si se recuperó, recargamos la página para limpiar estados
                                window.location.reload(); 
                            })
                            .catch(() => {
                                // Si falló de nuevo, vuelve a llamar a handleRetry
                                this.handleRetry();
                            });
                    }
                }
            );
        }, 1000);
        this.countdownInterval = countdownInterval;
    }

    stopTimer() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    }

    handleRetry() {
        let newRetryCount = parseInt(localStorage.getItem('retryCount')) || 0;
        newRetryCount += 1;
        
        // Estrategia de Backoff (Tiempos de espera)
        let nextTime = 5; // Default 5s
        
        if (newRetryCount > 3) {
            nextTime = 60; // Despues de 3 intentos, espera 1 minuto
        }
        
        // Si ya probamos más de 5 veces (aprox 3 mins total), paramos el automático
        // y dejamos que el usuario le de al botón "Reintentar" manualmente.
        if (newRetryCount > 5) {
            this.stopTimer();
            localStorage.setItem('retryCount', newRetryCount.toString());
            this.setState({ errorConfig: true, countdown: 0, retryCount: newRetryCount });
            return;
        }

        localStorage.setItem('retryCount', newRetryCount.toString());
        localStorage.setItem('countdown', nextTime.toString());

        this.setState({ retryCount: newRetryCount, countdown: nextTime, errorConfig: true }, this.startCountdown);
    }

    render() {
        if (this.state.configBusinessLoading) {
            return null; // O un Loading spinner simple
        }
        
        if (this.state.sistemaSuspendido) {
            return <Suspension title="Servicio suspendido por falta de pago" text=""/>;
        }

        // DEVOPS FIX: Logica simplificada. 
        // Si hay error de config y NO está OK => Pantalla de Reintentos.
        // No importa cuántos intentos lleve, siempre mostramos Reintentos (nunca NoDisponible).
        if (this.state.errorConfig && !this.state.configBusinessOk) {
            return <Reintentos countdown={this.state.countdown} />;
        }

        return (
            <IntlProvider locale={this.props.locale} messages={this.props.messages} defaultLocale="es">
                {this.state.authorized === null || !this.state.configBusinessOk ? null
                : (!this.state.authorized ?
                    (
                        <Router history={customHistory}>
                            <Switch>
                                <Route exact path='/' component={Login} />
                                <Route path='/activacion/:activationKey' component={Activate} />
                                <Route path='/olvide-clave' component={ForgotPassword} />
                                <Route path='/recuperar-clave/:activationKey' component={RecoverPassword} />
                                <Route path='/auth/azure/callback' component={AzureCallback} />
                                <Route path='/auth/google/callback' component={GoogleCallback} />
                                <Route path='/auth/okta/callback' component={OktaCallback} />
                                <Route path='/auth/pointer' component={PointerLogin} />
                                <Route path='/auth/geotab' component={GeotabLogin} />
                                <Route path='/auth/internal/login' component={InternalLogin} />
                                <Route path='/auth/2fa-totp' component={TwoFATotp} />
                                <Route path='/auth/2fa-totp-setup' component={TwoFATotpSetup} />
                                <Route path='/auth/2fa' component={TwoFA} />
                                <Route path='/reporte-formulario/:token' component={ReporteFormulario} />
                                <Route path='/safefeedback-formulario/:token' component={SafeFeedbackFormularioRespuesta} />
                                <Route component={Login} />
                            </Switch>
                        </Router>
                    ) : (
                        <Router history={customHistory}>
                            <Switch>
                                <Route path='/auth/pointer' component={PointerLogin} />
                                <Route path='/auth/geotab' component={GeotabLogin} />
                                <Route path='/auth/2fa' component={TwoFA} />
                                <Route path='/reporte-formulario/:token' component={ReporteFormulario} />
                                <Route path='/safefeedback-formulario/:token' component={SafeFeedbackFormularioRespuesta} />
                                <Layout authorized={this.state.authorized} />
                            </Switch>
                        </Router>
                    ))
                }
            </IntlProvider>
        );
    }
}

export default App;
